
































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  addDays,
  differenceInDays,
  format,
  isSameDay,
  isSunday,
  parse
} from "date-fns";
import ServiceScheduleDate from "../components/ServiceScheduleDate.vue";
import AppHeader from "../../../views/AppHeader.vue";
import VIconPrint from "../../../components/icons/VIconPrint.vue";
import VSearchBar from "../../../components/VSearchBar.vue";
import SearchScheduleBar, {
  SearchScheduleBarFormData
} from "../components/SearchScheduleBar.vue";
import ServiceTaskCell, {
  Props as ServiceTaskCellProps
} from "../components/ServiceTaskCell.vue";
import {
  getServiceTasks,
  GetServiceTasksResponse,
  ServiceTask
} from "@/servicetask/api/service-tasks-api";
import locale from "date-fns/locale/ja";

import draggable from "vuedraggable";
import StartProjectModal from "./StartProjectModal.vue";
import VToolbar from "@/components/V-Toolbar.vue";
import EditServiceTaskModal from "./EditServiceTaskModal.vue";
import assert from "assert";
import VServiceTaskTableCell from "../components/VServiceTaskTableCell.vue";
import VServiceTaskTable from "../components/VServiceTaskTable.vue";
import VServiceTaskTableRowHeader from "../components/VServiceTaskTableRowHeader.vue";

import "@/fonts/IPA-Gothic-normal";
import jsPDF from "jspdf";
import VDatePeriod from "../../../components/VDatePeriod.vue";
import VPrintButton from "../../../components/VPrintButton.vue";
import PrintServiceSchedule, {
  Props as PrintScheduleProps
} from "../components/PrintServiceSchedule.vue";
import { updateTaskDate } from "@/api/task-api";
import { countProjects } from "@/api/project-count-api";
import ProjectsCount from "../../../components/ProjectsCount.vue";
import SearchTaskModal from "./SearchTaskModal.vue";
import parseDate from "@/helpers/parseDate";
import { cloneDeep } from "lodash";
import { ProjectStatus } from "@/models/project-status";
import { Location } from "vue-router";
import DateHoliday from "date-holidays";

/**
 * 指定したidを工程リストの上位に持ってくる
 */
function sortedTasks(tasks: ServiceTask[], taskId: number) {
  const draft = ([] as ServiceTask[]).concat(tasks);
  draft.sort(a => (a.id === taskId ? -1 : 0));
  return draft;
}

@Component({
  components: {
    SearchTaskModal,
    ProjectsCount,
    PrintServiceSchedule,
    VPrintButton,
    VDatePeriod,
    VServiceTaskTable,
    VServiceTaskTableCell,
    VServiceTaskTableRowHeader,
    VToolbar,
    StartProjectModal,
    EditServiceTaskModal,
    VSearchBar,
    SearchScheduleBar,
    ServiceScheduleDate,
    ServiceTaskCell,
    AppHeader,
    VIconPrint,
    draggable
  }
})
export default class ServiceSchedulePage extends Vue {
  @Prop({ required: true }) serviceTaskTypeId!: string;
  // 表示確認用。?mode="view"を渡すと編集者でも閲覧モードにする
  @Prop({ default: "edit" }) defaultViewMode!: string;

  // TODO: 表示用の型にする
  schedule: GetServiceTasksResponse | null = null;

  futureProjectsCount = 0; // 未着工の現場件数
  pendingProjectsCount = 0; // 保留の現場件数

  date = new Date();

  startProjectId: number | null = null;
  editTaskId: number | null = null;
  projectModalDefaultTaskStatus = "";
  projectModalDefaultKeyword = "";

  searchTaskModalOpen = false;
  searchTaskSpecialKeyword = "";

  activeTaskId: number | null = null;

  holiday = new DateHoliday("JP");

  get user() {
    return this.$store.getters.user;
  }

  get editable(): boolean {
    return (
      this.defaultViewMode === "edit" &&
      this.user.can("service/service-tasks/write")
    );
  }

  get projectLinksVisible(): boolean {
    return Boolean(
      this.editable || (this.schedule && this.schedule.projectLinksVisible)
    );
  }

  get lastUpdateUser(): string {
    return (
      (this.schedule && this.schedule.staff && this.schedule.staff.name) || ""
    );
  }

  get lastUpdateDate(): string {
    if (this.schedule && this.schedule.updateDate) {
      return format(new Date(this.schedule.updateDate), "yyyy/M/d aK:mm");
    }
    return "";
  }

  get printScheduleProps(): PrintScheduleProps | null {
    if (!this.schedule) {
      return null;
    }
    return {
      schedule: {
        name: this.schedule.name,
        date: this.date,
        days: this.schedule.days.map(day => ({
          date: this.rowLabel(day.date),
          rawDate: day.date,
          items: day.tasks.map(
            (task): ServiceTaskCellProps => ({
              date: day.date,
              task: {
                ...task,
                constructionTasks: task.constructionTasks.map(t => ({
                  id: t.id,
                  shortName: t.shortName,
                  done: t.status === "done"
                }))
              }
            })
          )
        }))
      }
    };
  }

  get defaultQuery(): SearchScheduleBarFormData {
    return {
      client: String(this.$route.query["client"] || ""),
      operator: String(this.$route.query["operator"] || ""),
      constructionTask: String(this.$route.query["constructionTask"] || "")
    };
  }

  public created() {
    this.initServiceSchedule();
    this.initProjectsCount();
  }

  async initServiceSchedule() {
    this.getServiceSchedule().then(schedule => {
      this.schedule = schedule;
    });
  }

  private async getServiceSchedule() {
    // TODO: エラーを拾う
    return await getServiceTasks({
      serviceTaskTypeId: Number(this.serviceTaskTypeId),
      date: format(this.date, "yyyy-MM-dd"),
      staffId: this.$route.query.operator
        ? Number(this.$route.query.operator)
        : undefined,
      officeId: this.$route.query.client
        ? Number(this.$route.query.client)
        : undefined,
      constructionTaskId: this.$route.query.constructionTask
        ? Number(this.$route.query.constructionTask)
        : undefined
    });
  }

  @Watch("$route")
  onRouteUpdate() {
    this.initServiceSchedule();
  }

  canMoveTask(e: any): boolean {
    if (!this.editable) {
      // 編集権限がないとキャンセルする
      return false;
    }
    if (e.from.dataset["date"] === e.to.dataset["date"]) {
      // 移動元と移動先の日付が同じならキャンセルする
      return false;
    }
    if (e.from.dataset["date"] !== e.draggedContext.element.startDate) {
      // 工程の1日目以外はキャンセルする
      return false;
    }
    return true;
  }

  async moveTask(e: any) {
    if (!this.schedule) {
      throw new Error("工程表が読み込まれていません。");
    }

    const from: string = e.from.dataset["date"];
    const to: string = e.to.dataset["date"];

    const day = this.schedule.days.find(d => d.date === to);
    if (!day) {
      throw new Error("移動先の日付が見つかりません。");
    }

    const task = day.tasks[e.newIndex];
    if (!task) {
      throw new Error("対象の工程が見つかりません。");
    }

    // 施工日と終了日を書き換えて保存する
    const baseDate = parse(from, "yyyy-MM-dd", new Date());
    const newDate = parse(to, "yyyy-MM-dd", new Date());
    const moveDays = differenceInDays(newDate, baseDate);
    const newTask = {
      id: task.id,
      startDate: format(
        addDays(parse(task.startDate, "yyyy-MM-dd", new Date()), moveDays),
        "yyyy-MM-dd"
      ),
      endDate: format(
        addDays(parse(task.endDate, "yyyy-MM-dd", new Date()), moveDays),
        "yyyy-MM-dd"
      ),
      moveTogether: moveDays > 0 && confirm("後ろの工程も一緒に移動しますか？")
    };
    await updateTaskDate(newTask);
    await this.initServiceSchedule();
  }

  /**
   * 各列の最大数
   */
  get maxRows(): number {
    if (!this.schedule) {
      return 0;
    }
    return this.schedule.days.reduce((max, day) => {
      return Math.max(max, day.tasks.length);
    }, 0);
  }

  /**
   * 表示範囲の終端
   */
  get endDate(): Date {
    return addDays(this.date, 6);
  }

  get sortedSchedule(): GetServiceTasksResponse | null {
    if (!this.schedule) return null;

    const taskId = this.activeTaskId;
    if (!taskId) return this.schedule;

    return {
      ...this.schedule,
      days: this.schedule.days.map(day => ({
        ...day,
        tasks: sortedTasks(day.tasks, taskId)
      }))
    };
  }

  /**
   * 指定した日数移動する
   */
  moveDate(days: number) {
    const newDate = addDays(this.date, days);
    if (isSunday(newDate)) {
      // 日曜日になる場合、さらに1日とばす
      this.changeDate(addDays(newDate, days > 0 ? 1 : -1));
    } else {
      this.changeDate(newDate);
    }
  }

  /**
   * 特定の日付に移動する
   */
  changeDate(date: Date) {
    if (isSameDay(this.date, date)) {
      return;
    }
    this.date = date;
    this.initServiceSchedule();
  }

  /**
   * 現場を検索する
   * @param keyword
   */
  openSearchTaskModal(keyword: string) {
    if (!keyword) {
      return;
    }
    this.searchTaskSpecialKeyword = keyword;
    this.searchTaskModalOpen = true;
  }

  /**
   * 工程を検索する
   */
  search(query: SearchScheduleBarFormData) {
    this.$router.push({
      query: {
        client: query.client,
        operator: query.operator,
        constructionTask: query.constructionTask
      }
    });
  }

  /**
   * 工程を編集する
   */
  editTask(task: any) {
    assert(task.id, "task id is required");
    this.editTaskId = task.id;
  }

  cellProps(task: ServiceTask, date: string): ServiceTaskCellProps {
    return {
      task: Object.assign(cloneDeep(task), {
        constructionTasks: task.constructionTasks.map(t => ({
          id: t.id,
          shortName: t.shortName,
          done: t.status === "done"
        }))
      }),
      date,
      editable: this.editable
    };
  }

  startProject(projectId: number) {
    this.startProjectId = projectId;
  }

  rowLabel(date: string) {
    return format(parse(date, "yyyy-MM-dd", new Date()), "M/d(E)", { locale });
  }

  print() {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "px",
      format: "a3"
    });
    const component = this.$refs["printElement"] as Vue;
    if (!component) {
      throw new Error("Print Error");
    }
    const el = component.$el as HTMLElement;
    if (!el) {
      throw new Error("Print Error");
    }
    doc.html(el, {
      width: 892,
      windowWidth: el.clientWidth,
      callback: doc => {
        doc.save();
      }
    });
  }

  private initProjectsCount() {
    countProjects({ status: "未着工" }).then(data => {
      this.futureProjectsCount = data.projectsCount;
    });
    countProjects({ status: "保留" }).then(data => {
      this.pendingProjectsCount = data.projectsCount;
    });
  }

  selectTask(task: { id: number; date: string }) {
    this.activeTaskId = task.id;
    this.changeDate(parseDate(task.date));

    this.searchTaskModalOpen = false;
  }

  toProjectList(status: ProjectStatus): Location {
    return {
      name: "project-list",
      query: { status }
    };
  }
  isHoliday(date: string): boolean {
    return !!this.holiday.isHoliday(new Date(date));
  }
  isWeekend(date: string): boolean {
    // Get the day of the week (0 for Sunday, 6 for Saturday)
    const day = new Date(date).getDay();
    return day === 0 || day === 6;
  }
  highlightDateClass(date: string): string {
    if (this.isHoliday(date)) {
      return "holiday";
    }
    if (this.isWeekend(date)) {
      return "weekend";
    }
    return "";
  }
}
